import { render, staticRenderFns } from "./Gashapon.vue?vue&type=template&id=7f560517&scoped=true"
import script from "./Gashapon.vue?vue&type=script&lang=js"
export * from "./Gashapon.vue?vue&type=script&lang=js"
import style0 from "./Gashapon.vue?vue&type=style&index=0&id=7f560517&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f560517",
  null
  
)

export default component.exports